import React from "react";

const NewsCard = (props) => {
  const { title, author, content, urlToImage, publishedAt, description } =
    props.news;

  return (
    <>
      <div className="col-lg-4 col-12 mb-4">
        <div className="newsCard">
          <img src={urlToImage} className="img-fluid" alt="" />
          <div className=""></div>
        </div>
      </div>
    </>
  );
};

export default NewsCard;
